import React from "react";
import styles from "./ArticleNav.module.less";
import Container from "../Container/Container";
import { Link } from "react-router-dom";
import { ChapterArticle } from "../../api/cocApi";

export interface Props {
    nextArticle?: ChapterArticle;
    previousArticle?: ChapterArticle;
}

export default function ArticleNav(props: Props) {
    return (
        <nav className={styles.ArticleNav}>
            <Container className={styles["ArticleNav-container"]}>
                {props.nextArticle ? (
                    <Link
                        to={`/chapter/${props.nextArticle.tocIndex}`}
                        className={[styles["ArticleNav-item"], styles["ArticleNav-next"]].join(" ")}
                    >
                        <span className={styles["ArticleNav-itemLabel"]}>Next chapter</span>
                        <span className={styles["ArticleNav-itemText"]}>{props.nextArticle.heading}</span>
                    </Link>
                ) : (
                    <div className={[styles["ArticleNav-item"], styles["ArticleNav-next"]].join(" ")}></div>
                )}

                {props.previousArticle ? (
                    <Link
                        to={`/chapter/${props.previousArticle.tocIndex}`}
                        className={[styles["ArticleNav-item"], styles["ArticleNav-prev"]].join(" ")}
                    >
                        <span className={styles["ArticleNav-itemLabel"]}>Previous</span>
                        <span className={styles["ArticleNav-itemText"]}>{props.previousArticle.heading}</span>
                    </Link>
                ) : (
                    <div className={[styles["ArticleNav-item"], styles["ArticleNav-prev"]].join(" ")}></div>
                )}
            </Container>
        </nav>
    );
}
